import { Box, Flex, Heading } from "@chakra-ui/layout";
import { Spinner } from "@chakra-ui/spinner";
import React from "react";
import { useColorModeValue } from "@chakra-ui/react";
import { lightMode, darkMode } from "../../lib/models/color-mode-colors";

function FormLoadingOverlay({ label }: { label: string }) {
  const loadingOverlayBg = useColorModeValue(lightMode[300], darkMode[300]);
  return (
    <Box
      opacity="0.75"
      position="absolute"
      top={0}
      left={0}
      height="full"
      width="full"
      zIndex={45}
      backgroundColor={loadingOverlayBg}
    >
      <Flex
        position="sticky"
        top={0}
        left={0}
        height="full"
        maxHeight="100vh"
        width="full"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        backgroundColor={loadingOverlayBg}
      >
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="brand.500"
          size="xl"
        />
        <Heading as="h1" size="md" marginTop={6} fontWeight="bold">
          {label}
        </Heading>
      </Flex>
    </Box>
  );
}

export default FormLoadingOverlay;
